import type { AppContextType, ContextHeaderType } from "@shared/graphql.apollo";

import type { ReactNode } from "react";
import React, { createContext, useState, useEffect } from "react";
import { toAppContext, defaultContext } from "./utils";

type Props = {
  children: ReactNode;
  headers: ContextHeaderType;
};

export const AppContext = createContext<AppContextType>(defaultContext);

export const AppContextProvider: React.FC<Props> = ({ children, headers }) => {
  const [context, setContext] = useState(toAppContext(headers));

  useEffect(() => {
    if (headers && headers.locale !== context.locale) {
      setContext(toAppContext(headers));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headers.locale, headers.backend, headers.storeid]);

  return <AppContext.Provider value={context}>{children}</AppContext.Provider>;
};
